<template>
  <layout-vendor-dashboard-inner
    :vendor-id="vendorId"
    :back-link="{ name: 'company-vendorId-dashboard', params: { vendorId } }">
    <div class="vendor-form">
      <crud-edit v-bind="editConfiguration"></crud-edit>
    </div>
    <div class="margin-max-vertical company-form">
      <crud-edit
        item-src="user/current"
        :form-source="`entity/user/${userProfile.id}/update`"
        :submit-url="'user/' + userProfile.id"
        :form-config="companyFormConfig"
        :show-action-bar="false"
        item-mapper="raw" />
    </div>
  </layout-vendor-dashboard-inner>
</template>

<script>
import asyncOperations from "@/client/extensions/composition/asyncOperations.js";
import CrudEdit from "@/client/components/crud/customV1/Edit.vue";
import formConfig from "./formConfig";
import companyFormConfig from "@/client/applications/justopp/pages/user/dashboard/profile/company/formConfig.js";
import { computed } from "vue";
import { mapState } from "vuex";

export default {
  components: { CrudEdit },
  layout: {
    component: "noContainer",
    params: {
      title: "justopp.vendorProfile.pageTitle",
      subTitle: "justopp.vendorProfile.pageSubtitle",
      containerClass: "margin-remove-vertical",
    },
  },
  middleware: {
    requireVendorOrAdmin: { vendorIdFromParam: "vendorId" },
  },
  props: {
    // vendor ID
    vendorId: {
      type: String,
      default: 0,
    },
  },
  setup() {
    const { asyncOps, asyncOpsReady, asyncStatus } = asyncOperations();

    return { asyncOps, asyncOpsReady, asyncStatus, formConfig, companyFormConfig };
  },
  meta: "justopp.vendorProfile.browserTitle",
  data() {
    return {
      editConfiguration: {
        itemId: this.productId,
        subject: "product",
        itemSrc: computed(() => "ecommerce/vendor/" + this.vendorId),
        submitUrl: computed(() => {
          return "ecommerce/vendor/" + this.vendorId;
        }),
        showCancelButton: false,
        showActionBar: false,
        cancelRedirect: {
          name: "company-vendorId-dashboard",
          params: { vendorId: this.vendorId },
        },
        successRedirect: {
          name: "company-vendorId-dashboard",
          params: { vendorId: this.vendorId },
        },
        formConfig: this.formConfig,
        formSource: computed(() => `entity/vendor/${this.vendorId}/update`),
      },
      asyncData: {},
    };
  },
  computed: {
    ...mapState(["user"]),
    userProfile() {
      return this.user.user.profile;
    },
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss">
.vendor-form {
  .form {
    .fields {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;

      .top-block {
        order: 100;
        border: 1px solid red;
        flex: 0 0 100%;
      }

      .form__fieldset {
        flex: 0 0 48%;

        @media (max-width: 1024px) {
          flex: 0 0 100%;
        }

        &.translations {
          flex: 0 0 100%;
        }
      }
    }
  }
}
</style>

<style lang="scss" scoped></style>
